module.exports = __webpack_public_path__ + "img/warning.c0f98543.svg";